/** Severity + message shape shared by every party mutation result. */
interface PartyIssueLike {
  severity: string;
  message: string;
}

/**
 * Joins the error-severity issues of a party mutation result into one message.
 * Empty when the result carries only warnings.
 */
export function partyErrorMessage(issues: readonly PartyIssueLike[]): string {
  return issues
    .filter(issue => issue.severity === 'error')
    .map(issue => issue.message)
    .join('\n');
}
